import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Dropdown } from '@johnlewispartnership/wtr-ingredients/ingredients/Dropdown';
import { DropdownItem } from '@johnlewispartnership/wtr-ingredients/ingredients/Dropdown/DropdownItem';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/ingredients/LabeledControl';
import { Radio } from '@johnlewispartnership/wtr-ingredients/ingredients/Radio';
import classNames from 'classnames';
import { DEFAULT_SORT_BY, MOST_RELEVANT } from 'redux/modules/recipes/constants';
import { sortByParams, getKeyByValue } from 'redux/modules/recipes/utils/sort-by';
import styles from './index.scss';

const sortOptions = Object.keys(sortByParams);

const addRemoveMostRelevant = (pathname: string) => {
  if (!pathname.includes('recipes/search') && sortOptions[0] === MOST_RELEVANT) {
    sortOptions.shift(); // remove option when the page is not search
  }
  if (pathname.includes('recipes/search') && sortOptions[0] !== MOST_RELEVANT) {
    sortOptions.unshift(MOST_RELEVANT); // insert option when landing to the recipes search page
  }
  return sortOptions;
};

const SortBy = ({ defaultSortBy = DEFAULT_SORT_BY }: { defaultSortBy: string }) => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const definedSortOptions = addRemoveMostRelevant(pathname); // used to display the correct option when going back to the all-recipes page
  const defaultSortOption = definedSortOptions[0] === MOST_RELEVANT ? '' : defaultSortBy;

  const currentSortOption = getKeyByValue(searchParams.get('sortBy') || defaultSortOption);

  const onChange = (_e: React.SyntheticEvent, menuItem: HTMLElement) => {
    const option = menuItem.dataset.itemValue as string;

    if (option === MOST_RELEVANT) {
      searchParams.delete('sortBy');
    } else {
      searchParams.set('sortBy', sortByParams[option]);
    }
    searchParams.delete('page');
    searchParams.delete('startPage');

    setSearchParams(searchParams);
  };

  return (
    <div data-testid="sort-by-wrapper" className={classNames(styles.sortbyWrapper)}>
      <Dropdown
        label={`Sort by: ${currentSortOption}`}
        direction="bottom-end"
        handleItemSelect={onChange}
      >
        {definedSortOptions.map(option => {
          const checked = currentSortOption === option;

          return (
            <DropdownItem
              key={option}
              component={LabeledControl}
              data-item-value={option}
              control={<Radio readOnly tabIndex={-1} checked={checked} name={option} />}
              label={option}
              role="radio"
              aria-checked={checked}
            />
          );
        })}
      </Dropdown>
    </div>
  );
};

export default SortBy;
